<form class="contact-form" [formGroup]="contactForm" (submit)="onSubmit()" (focusin)="onFormInteraction()"
    (pointerdown)="onFormInteraction()">
    <div class="mb-3">
        <label for="nameInput" class="form-label text-tertiary fw-bold"
            >Name <span class="form__required-indicator">*</span></label
        >
        <div class="row">
            <div class="col">
                <input
                    type="text"
                    class="form-control"
                    id="nameInput"
                    aria-describedby="firstNameHelp"
                    formControlName="name"
                />
                <div id="firstNameHelp" class="form-text text-tertiary">
                    First <span class="form__required-indicator">*</span>
                </div>
            </div>
            <div class="col">
                <input
                    type="text"
                    class="form-control"
                    id="nameInput"
                    aria-describedby="lastNameHelp"
                    formControlName="lastname"
                />
                <div id="lastNameHelp" class="form-text text-tertiary">
                    Last <span class="form__required-indicator">*</span>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-6">
            <label for="emailInput" class="form-label text-tertiary fw-bold"
                >Email <span class="form__required-indicator">*</span></label
            >
            <input
                type="email"
                class="form-control"
                id="emailInput"
                formControlName="email"
            />
        </div>
        <div class="col-6">
            <label for="phoneInput" class="form-label text-tertiary fw-bold"
                >Phone <span class="form__required-indicator">*</span></label
            >
            <input
                type="tel"
                class="form-control"
                id="phoneInput"
                formControlName="phone"
            />
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-6">
            <label
                for="bookingReferenceNumberInput"
                class="form-label text-tertiary fw-bold"
                >Booking Reference Number</label
            >
            <input
                type="text"
                class="form-control"
                placeholder="#"
                id="bookingReferenceNumberInput"
                formControlName="bookingReferenceNumber"
            />
        </div>

        <div class="col-6">
            <label
                for="aboutQuestionInput"
                class="form-label text-tertiary fw-bold"
                >What's your question about?
                <span class="form__required-indicator">*</span></label
            >

            <select
                id="aboutQuestionInput"
                class="form-select"
                formControlName="aboutQuestion"
            >
                <option value="Information about touristic destinations">
                    Information about touristic destinations
                </option>
                <option value="Book a travel or activity" selected>
                    Book a travel or activity
                </option>
                <option value="Cancel a booking">Cancel a booking</option>
                <option value="Modify or cancel a booking">
                    Modify or cancel a booking
                </option>
                <option value="Talk with our representatives">
                    Talk with our representatives
                </option>
            </select>
        </div>
    </div>

    <div class="mb-3">
        <label for="messageTextarea" class="form-label text-tertiary fw-bold"
            >Message <span class="form__required-indicator">*</span></label
        >
        <textarea
            class="form-control"
            id="messageTextarea"
            rows="10"
            cols="50"
            formControlName="message"
        ></textarea>
    </div>

    <span class="opacity-75 form-text mb-3 d-block"
        ><span class="form__required-indicator">*</span> indicates required
        field</span
    >

    <div
        *ngIf="showSuccessMessage"
        class="alert alert-success mt-3 fade show"
        role="alert"
    >
        Your message has been sent successfully!
    </div>

    <div class="mb-3">
        <small class="text-muted d-block mb-2" *ngIf="!captchaToken">Security check loads on first interaction.</small>
        <div #recaptchaContainer></div>
    </div>

    <button
        type="submit"
        class="primary-btn border-0 text-decoration-none px-4 py-2 text-uppercase rounded-0 text-white text-center d-block"
        [disabled]="contactForm.invalid"
    >
        <span *ngIf="!isSubmitting">Submit</span>
        <span
            *ngIf="isSubmitting"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
        ></span>
        <span *ngIf="isSubmitting"> Sending...</span>
    </button>
</form>
